import React from "react";
import { Rocket, GraduationCap, Flame, Zap, Gem, Trophy, Award } from "lucide-react";

const ICONS = { rocket: Rocket, cap: GraduationCap, flame: Flame, zap: Zap, gem: Gem, whale: Trophy };
const TIERS = {
  green: { color: "#1EC62E", bg: "rgba(30,198,46,0.10)", border: "rgba(30,198,46,0.32)" },
  cyan: { color: "#00E5FF", bg: "rgba(0,229,255,0.10)", border: "rgba(0,229,255,0.28)" },
  orange: { color: "#FF6B00", bg: "rgba(255,107,0,0.10)", border: "rgba(255,107,0,0.32)" },
  gold: { color: "#FFD24A", bg: "rgba(255,210,74,0.12)", border: "rgba(255,210,74,0.34)" },
};

export default function ProfileBadges({ badges = [], className = "" }) {
  if (!badges || badges.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="profile-badges">
      {badges.map((b) => {
        const t = TIERS[b.tier] || TIERS.green;
        const Icon = ICONS[b.icon] || Award;
        return (
          <span key={b.id} title={b.desc} data-testid={`badge-${b.id}`}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl border text-xs font-bold"
            style={{ color: t.color, background: t.bg, borderColor: t.border }}>
            <Icon className="w-3.5 h-3.5" /> {b.label}
          </span>
        );
      })}
    </div>
  );
}
